import React from 'react'

const SendIcon = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.0583 7.59166L7.92498 4.02499C3.13331 1.62499 1.16664 3.59166 3.56664 8.38332L4.29164 9.83332C4.49998 10.2583 4.49998 10.75 4.29164 11.175L3.56664 12.6167C1.16664 17.4083 3.12498 19.375 7.92498 16.975L15.0583 13.4083C18.2583 11.8083 18.2583 9.19166 15.0583 7.59166ZM12.3666 11.125H7.86664C7.52498 11.125 7.24164 10.8417 7.24164 10.5C7.24164 10.1583 7.52498 9.87499 7.86664 9.87499H12.3666C12.7083 9.87499 12.9916 10.1583 12.9916 10.5C12.9916 10.8417 12.7083 11.125 12.3666 11.125Z" fill="white" />
  </svg>
)

export default SendIcon
